export const openInNewTab = url => window.open(url, '_blank', 'noopener,noreferrer')



// WEBPACK FOOTER //
// ./src/utils/openNewTab.ts